<template>
  <div class="mt-[34px] flex flex-wrap items-start justify-between gap-[15px]">
    <div class="flex flex-col">
      <div class="text-md font-semibold text-gpx_black-300 sm:mb-[2px] sm:text-lg">
        {{ heading }}
      </div>
      <div class="text-sm text-gpx_gray-200">{{ desc }}</div>
    </div>
    <div
        v-if="button"
        @click="doAction(button.action)"
        class="ml-auto mt-[4px] inline-flex cursor-pointer items-center gap-x-[4px] py-[10px]"
    >
      <component
          v-if="button.icon"
          :is="button.icon"
          class="h-[16px] w-[16px] text-gpx_porto-300"
      />
      <span class="inline-block text-sm font-medium text-gpx_porto-300">
        {{ button.label }}
      </span>
    </div>
    <div class="flex" v-if="(!isEmpty(filters) || !isEmpty(search)) && shouldShowFilters">
      <div v-if="!isEmpty(filters)">
        <DataFilter
            v-for="filter in filters"
            :type="filter.type"
            v-model="filter.value"
            :options="filter.options"
            :key="filter.type"
            class="pt-[5px]"
        />
      </div>
      <div v-if="!isEmpty(search)" class="pl-[15px] pt-[5px] sm:w-[286px] 2xl:pl-6">
        <Search v-model="search.value" :placeholder="search.placeholder" class="w-full" />
      </div>
    </div>
  </div>
</template>

<script>
import * as _ from 'lodash'
import { PlusIcon } from '@heroicons/vue/24/outline'
import Search from './Search.vue'
import DataFilter from "./DataFilter.vue";

export default {
  name: 'HeadingSection',
  components: {
    DataFilter,
    PlusIcon,
    Search,
  },

  props: {
    heading: {
      type: String,
      required: true
    },
    desc: {
      type: String,
      required: true
    },
    button: {
      type: Object,
      required: false
    },
    search: {
      type: Object,
      required: false
    },
    filters: Array,
    isEmptyData: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    shouldShowFilters() {
      // if there's data
      if (!this.isEmptyData) {
        return true
      }

      // if there's a search value in place
      if (this.search?.value) {
        return true
      }

      // if no filter
      if (!this.filters?.length) {
        return false
      }

      // if there's a filter with value
      const filterWithValue = this.filters.find((filter) => filter.value)
      if (filterWithValue) {
        return true
      }

      return false
    }
  },

  methods: {
    isEmpty: _.isEmpty,
    doAction(action) {
      if (action.mode === 'callback') {
        action.callback()
      }
      if (action.mode === 'route') {
        this.$router.push(action.route)
      }
    }
  }
}
</script>
